<template>
	<div class="card bg-light justify-content-center">
		<div class="card-body">
			<div class="d-flex align-items-center">
				<div class="spinner-grow spinner-grow-sm me-3"></div>
				<span>{{ $loc.fromResource('com.excel.fileProcessing')}}</span>
			</div>
		</div>
	</div>
</template>
